import * as CubeTree from '../../../cubeTree';

function addFreezerClass(cube: CubeNode): void {
    cube.jView.removeClass('shelvesbuild-e-shelves-freezer--last shelvesbuild-e-shelves-freezer--first')

    if (CubeTree.isOnlyOneFreezer(cube.id)) {
        cube.jView.addClass('shelvesbuild-e-shelves-freezer--last');
        return;
    }

    if (CubeTree.isFirstFreezer(cube.id)) {
        cube.jView.addClass('shelvesbuild-e-shelves-freezer--first');
    }

    if (CubeTree.isLastFreezer(cube.id)) {
        cube.jView.addClass('shelvesbuild-e-shelves-freezer--last');
    }
}

export {
    addFreezerClass
};
